<template>
  <div class="text-base">
    <div v-if="moneyMask" class="empty">
      <money
        v-bind="money"
        :ref="refName"
        :class="inputClasses"
        :value="value"
        class="form-input input-lg"
        :disabled="disabled"
        @input="(value) => $emit('input', value)"
        @blur.native="$emit('blur')"
      />
    </div>
    <input
      v-else-if="!mask"
      :class="inputClasses"
      :value="value"
      @change="$emit('input', $event.target.value)"
      :placeholder="placeholder"
      :type="type"
      :min="min"
      :max="max"
      :inputmode="inputMode"
      :ref="refName"
      :required="required"
      :disabled="disabled"
    />
    <the-mask
      v-else
      :class="inputClasses"
      :value="value"
      :mask="mask"
      :ref="refName"
      :placeholder="placeholder"
      :masked="masked"
      :inputmode="inputMode"
      :disabled="disabled"
      @input="(value) => $emit('input', value)"
    />
    <div v-if="validator && validator.$error">
      <ul
        v-for="(value, key) in validationsMessage"
        :key="key"
        class="input-error"
      >
        <li v-if="!validator[key]">
          {{ value }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { TheMask } from "vue-the-mask";
import { Money } from "v-money";

export default {
  components: { TheMask, Money },
  props: {
    value: [String, Number],
    error: Boolean,
    classCustom: String,
    type: {
      type: String,
      default: "text",
    },
    refName: {
      type: String,
    },
    placeholder: String,
    inputMode: String,
    mask: {
      type: [String, Array],
      default: null,
    },
    moneyMask: {
      type: Boolean,
      default: false,
    },
    moneySuffix: {
      type: String,
      default: " #",
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    masked: { default: true },
    required: { default: false },
    disabled: {
      type: Boolean,
      default: false,
    },
    validationsMessage: {
      type: Object,
      default: null,
    },
    validator: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: this.moneySuffix,
        precision: 2,
        masked: false,
      },
    };
  },
  computed: {
    inputClasses() {
      return [
        this.classCustom
          ? this.classCustom
          : "w-full bg-white default-input input-size-default text-gray-700 border-l-4 rounded px-4 leading-tight focus:outline-none transition focus:shadow focus:border-pink-500",
        this.error ? "fail-error" : "border",
        this.disabled ? "bg-gray-200" : "",
      ];
    },
  },
};
</script>
